import { KbCategory, KbSection } from '@evidentid/tprm-portal-lib/models/kb';

/** The chain of sections from a top-level section down to `sectionId`, outermost first.
 *
 * Categories are left out on purpose: the help landing page flattens them away, so a
 * breadcrumb naming one would point at a level the reader has never seen. An id that isn't
 * in the tree -- not loaded yet, or not browsable -- yields an empty path rather than a
 * guess, so callers can fall back to a shorter trail.
 */
export function findSectionPath(tree: KbCategory[], sectionId: string): KbSection[] {
    const walk = (sections: KbSection[], trail: KbSection[]): KbSection[] | null => {
        for (const section of sections) {
            const path = [ ...trail, section ];
            if (section.id === sectionId) {
                return path;
            }
            const found = walk(section.sections, path);
            if (found) {
                return found;
            }
        }
        return null;
    };

    for (const category of tree) {
        const path = walk(category.sections, []);
        if (path) {
            return path;
        }
    }
    return [];
}
